import React, { useEffect, useState } from 'react';
import {
  Box, AlertTitle, Alert, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Grid, TextField, IconButton, Container, Checkbox,
  FormControlLabel
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useCarrito } from '../context/CarritoContext';
import Navbar from '../Navbar/Navbar';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import TwoWheelerIcon from '@mui/icons-material/TwoWheeler';
import ModalAgregarDireccion from './AgregarDireccionModa';

const CarritoPedido = () => {
  const {
    carrito,
    totalCantidad,
    totalPrecio,
    limpiarCarrito,
    modificarCantidad,
    eliminarDelCarrito
  } = useCarrito();

  const Nombre = localStorage.getItem('Nombre');
  const Seguimiento = localStorage.getItem('Seguimiento');
  const Asesor = localStorage.getItem('Asesor');
  const PedidoExpress = Cookies.get('PedidoExpress');
  const IdUsuario = Cookies.get('IdUsuario');
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState('');
  const [comentario, setComentario] = useState('');
  const [direcciones, setDirecciones] = useState([]);
  const [productoNegado, setProductoNegado] = useState('');
  const [direccionSeleccionada, setDireccionSeleccionada] = useState("");
  const [pedidoExpressActivo, setPedidoExpressActivo] = useState(false);
  const [permitirPedidoExpress, setPermitirPedidoExpress] = useState(false);
  const [openDireccionModal, setOpenDireccionModal] = useState(false);
  const zona = Cookies.get('Facturacion');
  const ZONAS_MAYOREO = {
    "MAYOREO AGUASCALIENTES": [
      "BODEGA CALVILLO",
      "BODEGA RINCON",
      "SUC GALERIAS",
      "SUC MATRIZ",
      "SUC NORTE",
      "SUC ORIENTE",
      "SUC PASEOS",
      "SUC SUR",
    ],
    "MAYOREO JALISCO": [
      "CEDIS GUADALAJARA",
      "SUC GDL LOPEZ MATEOS",
      "SUC GDL MARIANO OTERO",
      "SUC GUADALAJARA",
    ],
    "MAYOREO PUERTO VALLARTA": [
      "SUC PUERTO VALLARTA"
    ],
    "MAYOREO LEON": ["SUC LEON"],
    "MAYOREO COLIMA": [],
    "MAYOREO DURANGO": ["BODEGA DURANGO"],
    "MAYOREO ZACATECAS": ["SUC GUADALUPE", "SUC ZACATECAS"],
  };
  const ZonaUsuario = Cookies.get("Facturacion");

  const productos = carrito.map(item => ({
    MSPN: item.MSPN,
    cantidad: item.cantidad
  }));
  const obtenerDirecciones = async () => {
    const payload2 = {
      idUsuario: IdUsuario,
    };
    try {
      const response = await fetch('https://bibliotecadlago.com/php/direcciones.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload2)
      });

      const data = await response.json();

      if (!response.ok) {
        setErrorMessage(data.message || 'Error al obtener direcciones');
        return;
      }
      setDirecciones(data.data)
    } catch (error) {
      console.error('Error de red:', error);
    }
  }
  const validarInventarioExpress = () => {
    const sucursalesZona = ZONAS_MAYOREO[ZonaUsuario] || [];

    return carrito.every((item) => {
      if (!item.inventario_detalle) return false;

      const inventarioZona = item.inventario_detalle.filter((inv) =>
        sucursalesZona.includes(inv.sucursal)
      );


      const totalDisponible = inventarioZona.reduce(
        (acc, inv) => acc + Number(inv.cantidad),
        0
      );

      return totalDisponible >= item.cantidad;
    });
  };
  useEffect(() => {
    obtenerDirecciones();
  }, [IdUsuario]);

  useEffect(() => {
    if (
      totalCantidad >= 1 &&
      totalCantidad <= 4 &&
      validarInventarioExpress()
    ) {
      setPermitirPedidoExpress(true);
    } else {
      setPermitirPedidoExpress(false);
      setPedidoExpressActivo(false);
    }
  }, [totalCantidad, carrito]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      IdUsuario,
      Usuario: localStorage.getItem('Nombre'),
      total: totalCantidad,
      productos,
      NombreCambio: Nombre,
      totalPrecio: totalPrecio,
      Comentario: comentario,
      ProducoNoEncontrado: productoNegado,
      Zona: zona,
    };

    const payloadPedidoExpress = {
      IdUsuario,
      total: totalCantidad,
      productos,
      NombreCambio: Nombre,
      totalPrecio: totalPrecio,
      Comentario: comentario,
      ProducoNoEncontrado: productoNegado,
      Direccion: direccionSeleccionada,
    };

    if (pedidoExpressActivo ){
          try {
      const response = await fetch('https://bibliotecadlago.com/php/pedidoExpress.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payloadPedidoExpress)
      });

      const data = await response.json();

      if (!response.ok) {
        setErrorMessage(data.message || 'Error al guardar el pedido');
        return;
      }

      limpiarCarrito();
      navigate('/pedidos.html');

    } catch (error) {
      console.log(error);
      setErrorMessage('Error de conexión con el servidor');
    }
    } else {
          try {
      const response = await fetch('https://bibliotecadlago.com/php/pedidov2.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (!response.ok) {
        setErrorMessage(data.message || 'Error al guardar el pedido');
        return;
      }

      limpiarCarrito();
      navigate('/pedidos.html');

    } catch (error) {
      console.log(error);
      setErrorMessage('Error de conexión con el servidor');
    }
    }
  };



  return (
    <>
      <Navbar />
      <Container maxWidth="lg">
        <Box p={3} display="flex" flexDirection="column" alignItems="stretch">
          {errorMessage && (
            <Alert severity="error" onClose={() => setErrorMessage('')}>
              <AlertTitle>Error</AlertTitle>
              {errorMessage}
            </Alert>
          )}

          <Typography
            variant="h4"
            gutterBottom
            sx={{
              color: '#cf1316',
              fontWeight: 'bold',
              textAlign: 'center'
            }}
          >
            Carrito de Pedido
          </Typography>

          <Grid container spacing={4}>
            <Grid item xs={12} md={6} sx={{ textAlign: 'left', marginRight: 8 }}>
              <Typography><b>Cliente:</b> {Nombre}</Typography>
              <Typography><b>Asesor:</b> {Asesor}</Typography>
              <Typography><b>Seguimiento:</b> {Seguimiento}</Typography>
              {(PedidoExpress === 1 || PedidoExpress === '1') && permitirPedidoExpress && (
                <Typography>
                  <FormControlLabel
                    control={
                      <Checkbox
                        icon={<TwoWheelerIcon />}
                        checkedIcon={<TwoWheelerIcon />}
                        checked={pedidoExpressActivo}
                        onChange={(e) => setPedidoExpressActivo(e.target.checked)}
                      />
                    }
                    label="Pedido Express"
                  />
                </Typography>

              )}
            </Grid>

            <Grid item xs={12}>
              <Box sx={{ width: '100%', overflowX: 'auto' }}>
                <TableContainer component={Paper} sx={{ mb: 3, minWidth: 50 }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">MSPN</TableCell>
                        <TableCell align="center">Descripción</TableCell>
                        <TableCell align="center">Cantidad</TableCell>
                        <TableCell align="center">Precio</TableCell>
                        <TableCell align="center">Eliminar</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {carrito.map((item) => (
                        <TableRow key={item.id}>
                          <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                            {item.MSPN}
                          </TableCell>
                          <TableCell align="center">{item.descripcion}</TableCell>
                          <TableCell align="center">
                            <TextField
                              type="number"
                              value={item.cantidad}
                              onChange={(e) => {
                                const valor = parseInt(e.target.value, 10);
                                if (!isNaN(valor) && valor > 0) {
                                  if (valor <= item.existencias) {
                                    modificarCantidad(item.MSPN, valor);
                                  }


                                }
                              }}
                              inputProps={{ min: 1 }}
                              size="small"
                              sx={{ width: 70 }}
                            />
                          </TableCell>
                          <TableCell align="center">{item.precio}</TableCell>
                          <TableCell align="center">
                            <IconButton
                              onClick={() => eliminarDelCarrito(item.MSPN)}
                              sx={{ color: 'red' }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                      <TableRow>
                        <TableCell colSpan={2} align="center">
                          <strong>Total</strong>
                        </TableCell>
                        <TableCell align="center">
                          <strong>{totalCantidad}</strong>
                        </TableCell>
                        <TableCell align="center">
                          <strong>{totalPrecio}</strong>
                        </TableCell>
                        <TableCell />
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>

          <Box mt={4} width="100%">
            <Box
              display="flex"
              flexWrap="wrap"
              justifyContent="center"
              gap={2}
              maxWidth={800}
            >
              {pedidoExpressActivo && (
                <Box
                  mt={4}
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                >
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    textAlign="center"

                  >
                    Elige la dirección para el Pedido Express
                  </Typography>
                  <Button
                    variant="contained"
                    onClick={() => setOpenDireccionModal(true)}
                    sx={{
                      backgroundColor: "#242c59",
                      "&:hover": { backgroundColor: "#1e2447" }
                    }}
                  >
                    Agregar Dirección
                  </Button>

                  <ModalAgregarDireccion
                    open={openDireccionModal}
                    onClose={() => setOpenDireccionModal(false)}
                    setDirecciones={setDirecciones}
                    IdUsuario={IdUsuario}
                    recargarDirecciones={obtenerDirecciones}
                  />

                  <Box width="100%" maxWidth={600} mb={2}>
                    {direcciones.map((dir) => (
                      <Paper
                        key={dir.Direccion}
                        onClick={() => setDireccionSeleccionada(dir.Direccion)}
                        sx={{
                          p: 2,
                          my: 1,
                          cursor: "pointer",
                          border: direccionSeleccionada === dir.Direccion
                            ? "2px solid #cf1316"
                            : "1px solid #ccc",
                          minWidth: 250,
                          textAlign: "center",
                        }}
                      >
                        {dir.Direccion}
                      </Paper>
                    ))}
                  </Box>
                </Box>
              )}

            </Box>
            <TextField
              label="Comentario"
              placeholder="Escribe algún comentario adicional sobre el pedido..."
              multiline
              rows={3}
              variant="outlined"
              fullWidth
              value={comentario}
              onChange={(e) => setComentario(e.target.value)}
            />
          </Box>

          <Box
            mt={4}
            display="flex"
            justifyContent="center"
            flexWrap="wrap"
            gap={2}
            width="100%"
          >
            <Button
              variant="contained"
              color="error"
              onClick={limpiarCarrito}
              fullWidth
              sx={{ maxWidth: 250 }}
            >
              Cancelar Pedido
            </Button>

            <Button
              variant="contained"
              onClick={handleSubmit}
              fullWidth
              sx={{
                backgroundColor: 'green',
                '&:hover': { backgroundColor: '#0b7d0b' },
                maxWidth: 250
              }}
            >
              Confirmar Pedido
            </Button>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default CarritoPedido;
